<template>
  <page-table />
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'financial-finRep-depExpense',
  components: { PageTable },
}
</script>
